export const discographyData = [
  {
    id: 'song-001',
    title: 'Talk To Me',
    artist: 'Bahjat',
    album: 'Single',
    albumArt: '/album-art/talk-to-me.jpg',
    releaseDate: '2017-02-17',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Producer'],
    links: [
      {
        platform: 'YouTube',
        url: 'https://www.youtube.com/watch?v=p9qnc8lhUJc',
        isPrimary: true
      },
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/bahjatmusic/talk-to-me'
      },
      {
        platform: 'Spotify',
        url: 'https://open.spotify.com/track/0hRvybRAkOEYjfnco46GZh'
      },
      {
        platform: 'Apple Music',
        url: 'https://music.apple.com/us/album/talk-to-me-single/1162183152'
      }
    ],
    description: 'Original demo production (no credits on final song or master)',
    credits: 'Produced by Ari Bradshaw',
    duration: '3:45',
    tags: ['hip-hop', 'r&b', 'demo']
  },
  {
    id: 'song-002',
    title: 'Fireflies',
    artist: 'Lackhoney',
    album: 'Single',
    albumArt: '/album-art/fireflies.jpg',
    releaseDate: '2017-02-07',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/lackhoney/fireflies-ft-khari-blasingame-noah-luna-lucy-davies-kumadiro-curt',
        isPrimary: true
      }
    ],
    description: 'Featuring KB, Noah Luna, Lucy DK, Curt Summers, Matt Zhang',
    credits: 'Produced and engineered by Ari Bradshaw',
    duration: '4:12',
    tags: ['hip-hop', 'r&b', 'collaboration']
  },
  {
    id: 'song-003',
    title: 'Location',
    artist: 'Lackhoney',
    album: 'Single',
    albumArt: '/album-art/location.jpg',
    releaseDate: '2017-03-22',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Engineer'],
    links: [
      {
        platform: 'YouTube',
        url: 'https://www.youtube.com/watch?v=U8V2ZNB1Qtg',
        isPrimary: true
      },
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/lackhoney/location'
      },
      {
        platform: 'Spotify',
        url: 'https://open.spotify.com/track/3OiFZSE0lbMoEgCjEcFJoE'
      },
      {
        platform: 'Apple Music',
        url: 'https://music.apple.com/us/album/location-feat-matt-zhang-mary/1290994991'
      }
    ],
    description: 'Featuring Matt Zhang, Mary',
    credits: 'Engineered by Ari Bradshaw',
    duration: '3:58',
    tags: ['hip-hop', 'r&b', 'engineering']
  },
  {
    id: 'song-004',
    title: 'These Days',
    artist: 'Lackhoney',
    album: 'Single',
    albumArt: '/album-art/these-days.jpg',
    releaseDate: '2017-04-12',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Engineer'],
    links: [
      {
        platform: 'YouTube',
        url: 'https://www.youtube.com/watch?v=pquKcUdtyxU',
        isPrimary: true
      },
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/lackhoney/ds-days-ft-lucy-dk-prod-lackhoney'
      }
    ],
    description: 'Featuring Lucy DK',
    credits: 'Engineered by Ari Bradshaw',
    duration: '4:25',
    tags: ['hip-hop', 'r&b', 'engineering']
  },
  {
    id: 'song-005',
    title: 'Nobody\'s Free (Until We All Are)',
    artist: 'Lucy DK',
    album: 'Single',
    albumArt: '/album-art/nobodys-free.jpg',
    releaseDate: '2017-04-15',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/lucydk/nobodys-free',
        isPrimary: true
      }
    ],
    description: 'A powerful anthem about freedom and unity',
    credits: 'Produced and engineered by Ari Bradshaw',
    duration: '4:30',
    tags: ['hip-hop', 'r&b', 'anthem']
  },
  {
    id: 'song-006',
    title: 'Box Chevy',
    artist: 'Lackhoney',
    album: 'Single',
    albumArt: '/album-art/box-chevy.jpg',
    releaseDate: '2017-04-20',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/lackhoney/boxchevy',
        isPrimary: true
      }
    ],
    description: 'A smooth hip-hop track with soulful elements',
    credits: 'Produced and engineered by Ari Bradshaw',
    duration: '3:45',
    tags: ['hip-hop', 'r&b', 'smooth']
  },
  {
    id: 'song-007',
    title: 'Last',
    artist: 'Valley Wide',
    album: 'Single',
    albumArt: '/album-art/last.jpg',
    releaseDate: '2017-04-25',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Producer', 'Engineer'],
    links: [
      {
        platform: 'YouTube',
        url: 'https://www.youtube.com/watch?v=example',
        isPrimary: true
      },
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/valleywidemusic/last'
      },
      {
        platform: 'Spotify',
        url: 'https://open.spotify.com/album/1ZyZLZvGQkafn3TaYG1TSH'
      },
      {
        platform: 'Apple Music',
        url: 'https://music.apple.com/us/album/last-single/1339938407'
      }
    ],
    description: 'A collaborative track with Valley Wide',
    credits: 'Produced and engineered by Ari Bradshaw',
    duration: '4:15',
    tags: ['hip-hop', 'r&b', 'collaboration']
  },
  {
    id: 'song-008',
    title: 'Mom Song',
    artist: 'Lackhoney',
    album: 'Single',
    albumArt: '/album-art/mom-song.jpg',
    releaseDate: '2017-05-14',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Engineer'],
    links: [
      {
        platform: 'YouTube',
        url: 'https://www.youtube.com/watch?v=OT89Kg8q8VM',
        isPrimary: true
      },
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/lackhoney/momsong'
      },
      {
        platform: 'Spotify',
        url: 'https://open.spotify.com/track/6o9gnPzzlVtcyVk4LIfha6'
      },
      {
        platform: 'Apple Music',
        url: 'https://music.apple.com/nz/album/mom-song-feat-mary-single/1291032699'
      }
    ],
    description: 'Featuring Mary',
    credits: 'Engineered by Ari Bradshaw',
    duration: '3:30',
    tags: ['hip-hop', 'r&b', 'engineering']
  },
  {
    id: 'song-009',
    title: 'Wonderful',
    artist: 'Lackhoney',
    album: 'Single',
    albumArt: '/album-art/wonderful.jpg',
    releaseDate: '2017-05-20',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Producer', 'Engineer'],
    links: [
      {
        platform: 'YouTube',
        url: 'https://www.youtube.com/watch?v=pB_Gp1GX90w',
        isPrimary: true
      },
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/lackhoney/wonderful'
      },
      {
        platform: 'Spotify',
        url: 'https://open.spotify.com/track/22r0RIPUi4PPS0scrzhJpB'
      },
      {
        platform: 'Apple Music',
        url: 'https://music.apple.com/us/album/wonderful-feat-lucy-dk-curt/1325459783'
      }
    ],
    description: 'Featuring Curt Summers, Lucy DK',
    credits: 'Produced and engineered by Ari Bradshaw',
    duration: '4:20',
    tags: ['hip-hop', 'r&b', 'collaboration']
  },
  {
    id: 'song-010',
    title: 'We Shall Overcome',
    artist: 'Lackhoney',
    album: 'Single',
    albumArt: '/album-art/we-shall-overcome.jpg',
    releaseDate: '2017-05-27',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Producer', 'Engineer'],
    links: [
      {
        platform: 'YouTube',
        url: 'https://www.youtube.com/watch?v=ZynJ2bQ8f_k',
        isPrimary: true
      },
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/lackhoney/weshallovercome'
      }
    ],
    description: 'Featuring Curt Summers, Lucy DK, Garvey',
    credits: 'Produced and engineered by Ari Bradshaw',
    duration: '4:45',
    tags: ['hip-hop', 'r&b', 'collaboration']
  },
  {
    id: 'song-011',
    title: 'Easy Love',
    artist: 'Valley / Lucy DK / Mary',
    album: 'Single',
    albumArt: '/album-art/easy-love.jpg',
    releaseDate: '2017-06-01',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/valley/easy-love',
        isPrimary: true
      }
    ],
    description: 'A collaborative track featuring multiple artists',
    credits: 'Produced and engineered by Ari Bradshaw',
    duration: '3:55',
    tags: ['hip-hop', 'r&b', 'collaboration']
  },
  {
    id: 'song-012',
    title: 'Self Work',
    artist: 'Lackhoney',
    album: 'Single',
    albumArt: '/album-art/self-work.jpg',
    releaseDate: '2017-06-10',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/lackhoney/self-work',
        isPrimary: true
      },
      {
        platform: 'Spotify',
        url: 'https://open.spotify.com/track/7aJYdMI2BUpeDdTDin36pg'
      },
      {
        platform: 'Apple Music',
        url: 'https://music.apple.com/us/album/self-work/1321624582'
      }
    ],
    description: 'A introspective track about personal growth',
    credits: 'Produced and engineered by Ari Bradshaw',
    duration: '4:10',
    tags: ['hip-hop', 'r&b', 'introspective']
  },
  {
    id: 'song-013',
    title: 'Bounce',
    artist: 'Lackhoney',
    album: 'Single',
    albumArt: '/album-art/bounce.jpg',
    releaseDate: '2017-07-14',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Engineer'],
    links: [
      {
        platform: 'YouTube',
        url: 'https://www.youtube.com/watch?v=SPdWzUnA1BY',
        isPrimary: true
      },
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/lackhoney/bounce'
      },
      {
        platform: 'Spotify',
        url: 'https://open.spotify.com/track/7sBMKVlfNeD3VFj336el9j'
      },
      {
        platform: 'Apple Music',
        url: 'https://music.apple.com/jp/album/bounce-single/1321601850'
      }
    ],
    description: 'A high-energy track with infectious rhythm',
    credits: 'Engineered by Ari Bradshaw',
    duration: '3:25',
    tags: ['hip-hop', 'r&b', 'high-energy']
  },
  {
    id: 'song-014',
    title: '24k',
    artist: 'Lackhoney',
    album: 'Single',
    albumArt: '/album-art/24k.jpg',
    releaseDate: '2017-07-21',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/lackhoney/24k-w-lucy-dk-curt-prod-lackhoney',
        isPrimary: true
      }
    ],
    description: 'Featuring Curt Summers, Lucy DK',
    credits: 'Produced and engineered by Ari Bradshaw',
    duration: '4:15',
    tags: ['hip-hop', 'r&b', 'collaboration']
  },
  {
    id: 'song-015',
    title: 'Wrong',
    artist: 'Lackhoney',
    album: 'Single',
    albumArt: '/album-art/wrong.jpg',
    releaseDate: '2017-08-04',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Producer', 'Engineer'],
    links: [
      {
        platform: 'YouTube',
        url: 'https://www.youtube.com/watch?v=RDNanwguopU',
        isPrimary: true
      },
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/lackhoney/wrong'
      },
      {
        platform: 'Spotify',
        url: 'https://open.spotify.com/track/4H6XEKxqX5LSsA8lIfMtZG'
      },
      {
        platform: 'Apple Music',
        url: 'https://music.apple.com/us/album/wrong-feat-lucy-dk-curt-single/1322027665'
      }
    ],
    description: 'Featuring Curt Summers, Lucy DK',
    credits: 'Produced and engineered by Ari Bradshaw',
    duration: '3:50',
    tags: ['hip-hop', 'r&b', 'collaboration']
  },
  {
    id: 'song-016',
    title: 'Hater Diss Track',
    artist: 'Lackhoney',
    album: 'Single',
    albumArt: '/album-art/hater-diss.jpg',
    releaseDate: '2017-08-15',
    genre: ['Hip Hop'],
    roles: ['Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/lackhoney/haterdisstrack',
        isPrimary: true
      }
    ],
    description: 'A response track to critics and haters',
    credits: 'Produced and engineered by Ari Bradshaw',
    duration: '3:20',
    tags: ['hip-hop', 'diss-track']
  },
  {
    id: 'song-017',
    title: 'Thanks for 20k Plays on SoundCloud',
    artist: 'Lackhoney',
    album: 'Single',
    albumArt: '/album-art/20k-thanks.jpg',
    releaseDate: '2017-08-25',
    genre: ['Hip Hop'],
    roles: ['Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/lackhoney/thanks-for-20k-streams-on-soundcloud-prod-lackhoney',
        isPrimary: true
      }
    ],
    description: 'A thank you track celebrating 20k plays',
    credits: 'Produced and engineered by Ari Bradshaw',
    duration: '2:45',
    tags: ['hip-hop', 'celebration']
  },
  {
    id: 'song-018',
    title: 'Cloud Walker',
    artist: 'Lackhoney',
    album: 'Single',
    albumArt: '/album-art/cloud-walker.jpg',
    releaseDate: '2017-09-01',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/lackhoney/cloudwalker',
        isPrimary: true
      }
    ],
    description: 'A dreamy track about floating through life',
    credits: 'Produced and engineered by Ari Bradshaw',
    duration: '4:05',
    tags: ['hip-hop', 'r&b', 'dreamy']
  },
  {
    id: 'song-019',
    title: 'Systematic',
    artist: 'Brett Koolik / A.C. / ARI BRADSHAW',
    album: 'Single',
    albumArt: '/album-art/systematic.jpg',
    releaseDate: '2017-09-10',
    genre: ['Hip Hop', 'Electronic'],
    roles: ['Lead Artist', 'Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/brettkoolik/systematic',
        isPrimary: true
      }
    ],
    description: 'A collaborative track with electronic elements',
    credits: 'Written, produced, and engineered by Ari Bradshaw',
    duration: '4:30',
    tags: ['hip-hop', 'electronic', 'collaboration']
  },
  {
    id: 'song-020',
    title: 'OMW',
    artist: 'Lackhoney',
    album: 'Single',
    albumArt: '/album-art/omw.jpg',
    releaseDate: '2017-09-20',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/lackhoney/omw',
        isPrimary: true
      }
    ],
    description: 'On My Way - a journey through life',
    credits: 'Produced and engineered by Ari Bradshaw',
    duration: '3:55',
    tags: ['hip-hop', 'r&b', 'journey']
  },
  {
    id: 'song-021',
    title: 'Best Thing Since Crack EP',
    artist: 'A.C. / ARI BRADSHAW',
    album: 'EP',
    albumArt: '/album-art/best-thing-ep.jpg',
    releaseDate: '2017-10-01',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Lead Artist', 'Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/ac/best-thing-since-crack-ep',
        isPrimary: true
      }
    ],
    description: 'A full EP collaboration with A.C.',
    credits: 'Written, produced, and engineered by Ari Bradshaw',
    duration: '15:30',
    tags: ['hip-hop', 'r&b', 'ep', 'collaboration']
  },
  {
    id: 'song-022',
    title: 'The One I Need',
    artist: 'Brett Koolik / ARI BRADSHAW',
    album: 'Single',
    albumArt: '/album-art/one-i-need.jpg',
    releaseDate: '2017-10-15',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Lead Artist', 'Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/brettkoolik/the-one-i-need',
        isPrimary: true
      }
    ],
    description: 'A soulful collaboration about finding the right person',
    credits: 'Written, produced, and engineered by Ari Bradshaw',
    duration: '4:20',
    tags: ['hip-hop', 'r&b', 'collaboration', 'soulful']
  },
  {
    id: 'song-023',
    title: 'Bad Gal',
    artist: 'Rozaye / A.C. / ARI BRADSHAW',
    album: 'Single',
    albumArt: '/album-art/bad-gal.jpg',
    releaseDate: '2017-10-25',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Lead Artist', 'Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/rozaye/bad-gal',
        isPrimary: true
      }
    ],
    description: 'A track celebrating confident women',
    credits: 'Written, produced, and engineered by Ari Bradshaw',
    duration: '3:45',
    tags: ['hip-hop', 'r&b', 'collaboration', 'empowerment']
  },
  {
    id: 'song-024',
    title: 'No Music',
    artist: 'Lackhoney / Mary',
    album: 'Single',
    albumArt: '/album-art/no-music.jpg',
    releaseDate: '2017-11-01',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/lackhoney/nomusic',
        isPrimary: true
      }
    ],
    description: 'Featuring Mary - a track about silence and reflection',
    credits: 'Produced and engineered by Ari Bradshaw',
    duration: '3:30',
    tags: ['hip-hop', 'r&b', 'collaboration', 'reflection']
  },
  {
    id: 'song-025',
    title: 'The Feb Project',
    artist: 'ARI BRADSHAW',
    album: 'Album',
    albumArt: '/album-art/feb-project.jpg',
    releaseDate: '2017-02-01',
    genre: ['Hip Hop', 'R&B', 'Electronic'],
    roles: ['Lead Artist', 'Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/aribradshaw/the-feb-project',
        isPrimary: true
      }
    ],
    description: 'A full album featuring multiple collaborations including:\n- "Day 1: Let Me Go" (with Lucy DK, Rachel Martin, Bahsil, Lackhoney)\n- "Day 2: Swervin\' Till Horizon" (with A.C., Lucy DK)\n- "Day 3: Can\'t Have Your Love" (with Brett Koolik, Lucy DK)\n- "Day 5: Take a Seat" (with Lucy DK, Rozaye)\n- "Day 6: Good Things Come and Go" (with Lucy DK)\n- "Day 8: I\'ll Be Fine" (with Brett Koolik, Lucy DK)\n- "Day 9: Smile (Untitled)" (with Lucy DK, Brett Koolik)\n- "Day 11: Level Up" (with Lackhoney, Rozaye)\n- "U Already Know" (with Lucy DK)\n- "Judge You" (with Lucy DK)\n- "God Help Me" (with Lucy DK)',
    credits: 'Written, produced, and engineered by Ari Bradshaw',
    duration: '45:00',
    tags: ['hip-hop', 'r&b', 'electronic', 'album', 'collaboration']
  },
  {
    id: 'song-026',
    title: 'Monday',
    artist: 'Rachel Martin / Lucy DK / ARI BRADSHAW',
    album: 'Single',
    albumArt: '/album-art/monday.jpg',
    releaseDate: '2017-12-01',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Lead Artist', 'Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/rachelmartin/monday',
        isPrimary: true
      }
    ],
    description: 'A track about the start of the week',
    credits: 'Written, produced, and engineered by Ari Bradshaw',
    duration: '3:55',
    tags: ['hip-hop', 'r&b', 'collaboration']
  },
  {
    id: 'song-027',
    title: 'Gameplan',
    artist: 'Lackhoney',
    album: 'Single',
    albumArt: '/album-art/gameplan.jpg',
    releaseDate: '2017-12-10',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/lackhoney/gameplan',
        isPrimary: true
      }
    ],
    description: 'A strategic track about planning for success',
    credits: 'Produced and engineered by Ari Bradshaw',
    duration: '4:10',
    tags: ['hip-hop', 'r&b', 'strategy']
  },
  {
    id: 'song-028',
    title: 'Puzzle (ARI BRADSHAW Remix)',
    artist: 'OMG / Brett Koolik',
    album: 'Single',
    albumArt: '/album-art/puzzle-remix.jpg',
    releaseDate: '2017-12-20',
    genre: ['Hip Hop', 'Electronic'],
    roles: ['Remixer', 'Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/omg/puzzle-ari-bradshaw-remix',
        isPrimary: true
      }
    ],
    description: 'A remix of the original Puzzle track',
    credits: 'Remixed, produced, and engineered by Ari Bradshaw',
    duration: '4:15',
    tags: ['hip-hop', 'electronic', 'remix']
  },
  {
    id: 'song-029',
    title: 'Beth\'s in China',
    artist: 'Lucy DK / ARI BRADSHAW',
    album: 'Single',
    albumArt: '/album-art/beths-in-china.jpg',
    releaseDate: '2018-01-01',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Lead Artist', 'Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/lucydk/beths-in-china',
        isPrimary: true
      }
    ],
    description: 'A track about long-distance relationships',
    credits: 'Written, produced, and engineered by Ari Bradshaw',
    duration: '3:40',
    tags: ['hip-hop', 'r&b', 'collaboration', 'long-distance']
  },
  {
    id: 'song-030',
    title: 'Chaos & Confusion EP',
    artist: 'Valley / Lucy DK',
    album: 'EP',
    albumArt: '/album-art/chaos-confusion.jpg',
    releaseDate: '2018-01-15',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/valley/chaos-confusion-ep',
        isPrimary: true
      }
    ],
    description: 'A full EP exploring themes of chaos and confusion',
    credits: 'Produced and engineered by Ari Bradshaw',
    duration: '20:00',
    tags: ['hip-hop', 'r&b', 'ep', 'collaboration']
  },
  {
    id: 'song-031',
    title: 'lets go on a movie date',
    artist: 'Sarah Steil / ARI BRADSHAW',
    album: 'Single',
    albumArt: '/album-art/movie-date.jpg',
    releaseDate: '2018-02-01',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Lead Artist', 'Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/sarahsteil/lets-go-on-a-movie-date',
        isPrimary: true
      }
    ],
    description: 'A romantic track about going to the movies',
    credits: 'Written, produced, and engineered by Ari Bradshaw',
    duration: '3:25',
    tags: ['hip-hop', 'r&b', 'collaboration', 'romantic']
  },
  {
    id: 'song-032',
    title: 'Quattro',
    artist: 'A.C. / ARI BRADSHAW',
    album: 'Single',
    albumArt: '/album-art/quattro.jpg',
    releaseDate: '2018-02-15',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Lead Artist', 'Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/ac/quattro',
        isPrimary: true
      }
    ],
    description: 'A track with four distinct sections',
    credits: 'Written, produced, and engineered by Ari Bradshaw',
    duration: '4:45',
    tags: ['hip-hop', 'r&b', 'collaboration']
  },
  {
    id: 'song-033',
    title: 'wish i knew',
    artist: 'Sarah Steil / ARI BRADSHAW',
    album: 'Single',
    albumArt: '/album-art/wish-i-knew.jpg',
    releaseDate: '2018-03-01',
    genre: ['Hip Hop', 'R&B'],
    roles: ['Lead Artist', 'Producer', 'Engineer'],
    links: [
      {
        platform: 'SoundCloud',
        url: 'https://soundcloud.com/sarahsteil/wish-i-knew',
        isPrimary: true
      }
    ],
    description: 'A reflective track about uncertainty',
    credits: 'Written, produced, and engineered by Ari Bradshaw',
    duration: '3:50',
    tags: ['hip-hop', 'r&b', 'collaboration', 'reflection']
  }
];

// Helper function to get all unique genres
export const getAllGenres = () => {
  const genres = new Set();
  discographyData.forEach(song => {
    song.genre.forEach(genre => genres.add(genre));
  });
  return Array.from(genres).sort();
};

// Helper function to get all unique roles
export const getAllRoles = () => {
  const roles = new Set();
  discographyData.forEach(song => {
    song.roles.forEach(role => roles.add(role));
  });
  return Array.from(roles).sort();
};

// Helper function to get all unique platforms
export const getAllPlatforms = () => {
  const platforms = new Set();
  discographyData.forEach(song => {
    song.links.forEach(link => platforms.add(link.platform));
  });
  return Array.from(platforms).sort();
}; 